<template>
  <div class="productList" v-wechat-title="title">
    <div
      class="list"
      style="margin-bottom: 0"
      v-if="(changetype == 0 || changetype == 2) && list1.length"
    >
      <span v-if="changetype == 0" class="f15 color-FC0324">超值换购</span>
      <div class="itemA" v-for="(item, index) in list1" :key="index">
        <div class="labelWrap flex-js-ac">
          <div class="tips" style="width: 100%">
            <p>{{ item.tipLable }}</p>
            <p>{{ item.tipTime }}</p>
          </div>
        </div>
        <div class="itemWrap" v-for="(itemB, indexB) in item.changebuylist" :key="item.skuid">
          <div class="item flex-ac">
            <van-checkbox
              v-model="itemB.ischoose"
              checked-color="#FC0324"
              @click="choice(index, indexB, 'changebuy')"
            ></van-checkbox>
            <img class="flex-s" v-lazy="itemB.img_path" @click.stop="godetail(itemB)" />
            <div class="rightBox" @click.stop="godetail(itemB)">
              <p class="name over-ell-1">{{ itemB.name }}</p>
              <p class="oldPrice">原价¥{{ itemB.cost_price }}</p>
              <div class="flex-js-ac">
                <p class="currentPrice">
                  <span class="lable">换购价¥</span>
                  <span class="price">{{ itemB.changebuy_price }}</span>
                </p>
                <div class="stepBox flex-js-ac">
                  <div
                    :class="[itemB.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                    @click.stop="addToCart(0, index, indexB, itemB, 'changebuy')"
                  ></div>
                  <div class="num">{{ itemB.num }}</div>
                  <div
                    :class="[itemB.num < itemB.canbuycnt ? 'can' : '', 'add stepBtn']"
                    @click.stop="addToCart(1, index, indexB, itemB, 'changebuy')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ysale" v-if="itemB.presaletime" style="padding-left: 0.1rem">
            <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
            <img src="../../assets/images/presell.png" />
            <div class="txt">预售发货时间：{{ itemB.presaletime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="list list2" v-if="(changetype == 0 || changetype == 1) && list2.length">
      <span class="f15" v-if="changetype == 0">超值加购</span>
      <div class="itemA" v-for="(item, index) in list2" :key="index">
        <div
          class="itemWrap"
          v-for="(itemB, indexB) in item.changebuylist"
          :key="item.skuid"
          :ischoose="itemB.ischoose"
        >
          <div class="item flex-ac">
            <van-checkbox
              v-model="itemB.ischoose"
              checked-color="#FC0324"
              @click="choice(index, indexB, 'exchangebuy')"
            ></van-checkbox>
            <img class="flex-s" v-lazy="itemB.img_path" @click.stop="godetail(itemB)" />
            <div class="rightBox" @click.stop="godetail(itemB)">
              <p class="name over-ell-1">{{ itemB.name }}</p>
              <p class="oldPrice">原价¥{{ itemB.cost_price }}</p>
              <div class="flex-js-ac">
                <p class="currentPrice">
                  <span class="lable">加购价¥</span>
                  <span class="price">{{ itemB.changebuy_price }}</span>
                </p>
                <div class="stepBox flex-js-ac">
                  <div
                    :class="[itemB.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                    @click.stop="addToCart(0, index, indexB, itemB, 'exchangebuy')"
                  ></div>
                  <div class="num">{{ itemB.num }}</div>
                  <div
                    :class="[itemB.num < itemB.canbuycnt ? 'can' : '', 'add stepBtn']"
                    @click.stop="addToCart(1, index, indexB, itemB, 'exchangebuy')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ysale" v-if="itemB.presaletime" style="padding-left: 0.1rem">
            <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
            <img src="../../assets/images/presell.png" />
            <div class="txt">预售发货时间：{{ itemB.presaletime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnBox">
      <div class="submitBtn" @click="submit">
        确定{{ totalNumber1 + totalNumber2 ? '(' + (totalNumber1 + totalNumber2) + ')' : '' }}
      </div>
    </div>
  </div>
</template>

<script>
import { unencryption, before_addOrder } from '../../assets/common/js/config'
import { Tag } from 'vant'

export default {
  name: 'allProductList',
  data() {
    return {
      list1: [], // 换购列表
      list2: [], // 加购列表
      totalNumber1: 0,
      totalNumber2: 0,
      maxcanbuycnt1: 0,
      maxcanbuycnt2: 0,
      title: '',
      changetype: 0
    }
  },
  components: {
    [Tag.name]: Tag
  },
  created() {
    if (this.$route.query.isexchange == 1) {
      this.title = this.$route.meta.title = '超值加购'
      this.changetype = 1
    } else if (this.$route.query.changebuystatus == 1) {
      this.title = this.$route.meta.title = '超值换购'
      this.changetype = 2
    } else {
      this.title = this.$route.meta.title = '超值福利'
      this.changetype = 0
    }
    this.getData()
  },
  methods: {
    getData() {
      let that = this,
        skuids = this.$route.query.skuids,
        url,
        itemnum = this.$route.query.itemnum ? this.$route.query.itemnum : ''

      url = this.$ajax.getExchangeAllList_URL + '?skuids=' + skuids + '&itemnum=' + itemnum
      url = this.$route.query.oid ? url + '&orderid=' + this.$route.query.oid : url

      this.$customRequestAjax(url).then(function (res) {
        if (res.data.code === 200) {
          if (res.data.exchangelist.length) that.getGoodsList(res.data.exchangelist, 'changebuy')
          if (res.data.addlist.length) that.getGoodsList(res.data.addlist, 'exchangebuy')
        }
      })
    },
    getGoodsList(data, type) {
      let that = this,
        list = data
      if (type == 'changebuy') {
        that.maxcanbuycnt1 = list[0].maxcanbuycnt
      }
      for (let i = 0; i < list.length; i++) {
        let changebuytip = list[i].changebuytip,
          changebuylist = list[i].changebuylist

        changebuytip = changebuytip.replace(/[\r\n]/g, '&')
        list[i].tipLable = changebuytip.substring(0, changebuytip.indexOf('&'))
        list[i].tipTime = changebuytip.substring(changebuytip.indexOf('&') + 1)

        for (let j = 0; j < changebuylist.length; j++) {
          if (type == 'changebuy') {
            changebuylist[j].num = changebuylist[j].canbuycnt
          } else {
            if (list[i].maxcanbuycnt == 100000) {
              changebuylist[j].num = 1
            } else {
              changebuylist[j].num = changebuylist[j].canbuycnt
            }
          }
        }
      }
      if (type == 'changebuy') {
        that.list1 = list
      } else {
        that.list2 = list
      }
      that.count(type)
    },
    // 计算已选中的商品数量
    count(type) {
      let totalNumber = 0,
        list
      if (type == 'changebuy') {
        list = this.list1
      } else {
        list = this.list2
      }
      for (let i = 0; i < list.length; i++) {
        list[i].exchangetotalNumber = 0
        let changebuylist = list[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose) {
            totalNumber += changebuylist[j].num
            list[i].exchangetotalNumber += parseInt(changebuylist[j].num)
          }
        }
      }
      if (type == 'changebuy') {
        this.totalNumber1 = totalNumber
      } else {
        this.totalNumber2 = totalNumber
      }
    },
    // 商品数量加减
    addToCart(type, index, indexB, item, typeBtn) {
      if (typeBtn == 'changebuy') {
        if (this.totalNumber1 + 1 > this.maxcanbuycnt1 && type == 1) {
          this.$toast('超出最大可加购数量')
          return
        }
      } else {
        if (
          this.list2[index].exchangetotalNumber + 1 > this.list2[index].maxcanbuycnt &&
          type == 1
        ) {
          this.$toast('超出最大可加购数量')
          return
        }
      }
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }
      if (typeBtn == 'changebuy') {
        this.list1[index].changebuylist[indexB].num = num
      } else {
        this.list2[index].changebuylist[indexB].num = num
      }
      this.count(typeBtn)
    },
    // 选择/取消选择
    choice(index, indexB, type) {
      if (type == 'changebuy') {
        if (
          this.totalNumber1 + this.list1[index].changebuylist[indexB].num > this.maxcanbuycnt1 &&
          this.list1[index].changebuylist[indexB].ischoose
        ) {
          this.list1[index].changebuylist[indexB].ischoose = 0
          this.$toast('超出最大可加购数量')
          return
        }
        this.list1[index].changebuylist[indexB].ischoose = this.list1[index].changebuylist[indexB]
          .ischoose
          ? 1
          : 0
      } else {
        let exchangetotalnumtemp = 0
        this.list2[index].changebuylist.map((item, idx) => {
          if (item.ischoose && idx != indexB && item.singlechoose == 1) {
            item.ischoose = 0
          } else if (
            this.list2[index].changebuylist[indexB].ischoose &&
            this.list2[index].changebuylist[indexB].singlechoose == 1 &&
            idx != indexB
          ) {
            item.ischoose = 0
          }
          if (item.ischoose) {
            exchangetotalnumtemp += parseInt(item.num)
          }
        })
        if (
          exchangetotalnumtemp > this.list2[index].maxcanbuycnt &&
          this.list2[index].changebuylist[indexB].ischoose
        ) {
          this.list2[index].changebuylist[indexB].ischoose = 0
          this.$toast('超出最大可加购数量')
          return
        }
        this.list2[index].changebuylist[indexB].ischoose = this.list2[index].changebuylist[indexB]
          .ischoose
          ? 1
          : 0
        this.$forceUpdate()
      }
      this.count(type)
    },
    godetail(items) {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid,
          type: 'changebuyproductdetail'
        }
      })
    },
    // 跳转至加购规则页
    goExchangeRule(changebuyrule) {
      if (this.$route.query.isexchange == 1) return
      window.location.href =
        'static/wx/html/exchangeRule.html?acttime=' +
        changebuyrule.acttime +
        '&productname=' +
        encodeURIComponent(changebuyrule.productname) +
        '&changebuyproductname=' +
        encodeURIComponent(changebuyrule.changebuyproductname)
    },
    // 提交加购商品
    submit() {
      let currentList = [],
        currentList1 = [],
        currentList2 = [],
        list1 = this.list1,
        list2 = this.list2,
        url,
        shopConfirmResult,
        skuids = [],
        buynum = [],
        totalnum = 0,
        totalmoney = 0,
        noneList = []
      shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (shopConfirmResult) shopConfirmResult.notbuygift_changebuy_money = 0
      for (let i = 0; i < list1.length; i++) {
        let changebuylist = list1[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose && changebuylist[j].canbuycnt) {
            currentList.push(changebuylist[j])
            currentList1.push(changebuylist[j])
          }
        }
      }
      for (let i = 0; i < list2.length; i++) {
        let changebuylist = list2[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose) {
            currentList.push(changebuylist[j])
            currentList2.push(changebuylist[j])
          }
        }
      }

      if (this.$route.query.type == 'orderInfo' && !currentList.length) {
        this.$toast('请选择要加购的商品')
        return
      }

      if (this.$route.query.type == 'orderInfo') {
        for (let i = 0; i < currentList.length; i++) {
          if (currentList[i].num == 0) {
            noneList.push(currentList[i].name)
          }
        }

        let tooltip = noneList.join()
        if (tooltip) {
          this.$toast(tooltip + '无加购资格')
          return
        }
      }

      currentList.forEach((item) => {
        skuids.push(item.skuid)
        buynum.push(item.num)
        totalnum += item.num
        totalmoney += item.num * item.changebuy_price
        if (item.isfullgift == 0 && shopConfirmResult) {
          shopConfirmResult.notbuygift_changebuy_money += item.num * item.changebuy_price
        }
      })

      if (this.$route.query.type != 'orderInfo' && !currentList.length) {
        shopConfirmResult.changebuy_list = JSON.stringify(currentList)
        shopConfirmResult.changebuyskuids = skuids
        shopConfirmResult.changebuynums = buynum
        before_addOrder(shopConfirmResult)
        if (this.$route.query.path) {
          this.$router.replace({
            path: unencryption(this.$route.query.path)
          })
        } else {
          let obj = {}
          if (this.$route.query.isexchange == 1) obj.isexchange = 1
          this.$router.replace({
            path: '/order',
            query: obj
          })
        }
        return
      }

      url = this.$ajax.checkOrder_URL + '?skuids=' + skuids.join() + '&buynum=' + buynum.join()
      url = this.$route.query.oid ? url + '&oid=' + this.$route.query.oid : url
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (this.$route.query.type == 'orderInfo') {
            shopConfirmResult = {
              skuidArr: skuids,
              itemNum: buynum,
              skuidArrOversea: [],
              orderid: this.$route.query.oid,
              liveId: [],
              from: 2,
              orderfrom: 1,
              itemNumOversea: [],
              LiveIdArrOversea: [],
              totalmoney: totalmoney,
              totalnum: totalnum,
              orderHadOnShow: 0,
              isInitData: 1,
              changebuy_list: JSON.stringify([]),
              act_class:
                currentList1.length > 0 && currentList2.length > 0
                  ? 'allchangebuy'
                  : currentList1.length > 0
                  ? 'changebuy'
                  : currentList2.length > 0
                  ? 'exchangebuy'
                  : '' // allchangebuy 换购+加购标识， changebuy 换购标识，exchangebuy 加购标识
            }
            before_addOrder(shopConfirmResult)
          } else {
            shopConfirmResult.changebuy_list = JSON.stringify(currentList)
            shopConfirmResult.changebuyskuids = skuids
            shopConfirmResult.changebuynums = buynum
            localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          }
          if (this.$route.query.path) {
            this.$router.push({
              path: unencryption(this.$route.query.path)
            })
          } else {
            let obj = {}
            this.$router.push({
              path: '/order',
              query: obj
            })
          }
        } else {
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/productList.scss';
.productList {
  .list {
    background: #ffffff;
    border-radius: 0.03rem;
    margin-bottom: 0.7rem;
    padding-bottom: 0;
    overflow: hidden;
    > span {
      display: block;
      width: 0.75rem;
      height: 0.29rem;
      background: #ffeff1;
      border-radius: 0.03rem 0 0.03rem 0;
      margin-bottom: 0.15rem;
      text-align: center;
      line-height: 0.29rem;
    }
    &.list2 {
      > span {
        color: #ffa345;
        background: #fff5ea;
      }
    }
    .itemA {
      padding-bottom: 0;
      margin-bottom: 0;
      &:last-of-type {
        padding-bottom: 0.15rem;
      }
    }
    .item {
      margin: 0.15rem 0.1rem 0;
      padding: 0;
    }
  }
}
.btnBox {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #fff;
  .submitBtn {
    position: absolute;
    right: 0.1rem;
    top: 0.06rem;
    width: 1.1rem;
    height: 0.38rem;
    line-height: 0.38rem;
    background: linear-gradient(to right, #fc0324, #ff144f);
    border-radius: 0.2rem;
    font-size: 0.16rem;
    color: #fff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productList/allProductList.vue